// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentMethodsEmpty_container__3QzCP","icon":"PaymentMethodsEmpty_icon__3dGUg","description":"PaymentMethodsEmpty_description__3vlte"};